import { useBackends as storeUseBackends } from "@/_store/backend"

export const useBackends = storeUseBackends
